import React, { useState } from 'react';
import 'react-dates/initialize';
import { DateRangePicker as DRP } from 'react-dates';
import 'react-dates/lib/css/_datepicker.css';
import './DateRangePicker.scss';
import { Moment } from 'moment';
import styled from 'styled-components';
import { IconButton } from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Clear';

interface Props {
  title: string;
  value: { startDate: Moment | null; endDate: Moment | null };
  onChange: (arg: { startDate: Moment | null; endDate: Moment | null }) => void;
}

const Wrapper = styled.div`
  border-bottom: 1px solid grey;
  margin-bottom: 16px;
`;

const Title = styled.div`
  font-size: 12px;
  color: rgba(0, 0, 0, 0.54);
`;

const DateRangePicker: React.FunctionComponent<Props> = props => {
  const [focusedInput, setFocusedInput] = useState<'startDate' | 'endDate' | null>(null);

  return (
    <Wrapper>
      <Title>{props.title}</Title>
      <DRP
        startDate={props.value.startDate}
        startDateId="start_id"
        endDate={props.value.endDate}
        endDateId="end_id"
        onDatesChange={props.onChange}
        focusedInput={focusedInput}
        onFocusChange={setFocusedInput}
        noBorder
        small
        isOutsideRange={() => false}
      />
      <IconButton aria-label="Delete" onClick={() => props.onChange({ startDate: null, endDate: null })}>
        <DeleteIcon />
      </IconButton>
    </Wrapper>
  );
};

export default DateRangePicker;
